import React from 'react';
import { HyperdbForm } from '../../../../hyperdb';
import ReviewForm from '../components/Form';

class Form extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {
    this.props.api.property.getObjects({
      queryOptions: [['id', 'name'], { order: { name: 'asc' } }],
    });
  }
  render() {
    const properties = this.props.api.getState('property').properties || [];
    return (
      <div>
        <ReviewForm
          review={ this.props.objectData }
          properties={ properties }
          onChange={ this.handleChange }
          availableLanguages={ this.props.availableLanguages }
        />
      </div>
    );
  }
  handleChange(attributeName, field) {
    const { name, value } = field;
    this.props.updateEditedObject({ attributeName, value });
  }
}

Form.propTypes = {
  api: React.PropTypes.object,
  objectData: React.PropTypes.object,
};

export default HyperdbForm(Form, {
  namespace: 'propertyReview',
  mountedUrl: '/content/property-reviews',
  titleNew: 'Create new review',
  titleEdit: 'Edit review',
  displayName: (object) => '',
  checkIsValid: (props) => {
    const hasProperty = !!(props.objectData.property && props.objectData.property.value[1]);
    return hasProperty && props.objectData.guest_name && props.objectData.guest_name && props.objectData.date && props.objectData.language;
  },
});



// WEBPACK FOOTER //
// ./src/frontend/modules/content/property-review/containers/Form.jsx